module.exports = __webpack_public_path__ + "img/_ic_arrow_dyn_neg.ba37d3a2.svg";